<template>
  <b-container fluid>
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>Filtros de Busca</strong>
        </h4>
        <a-form layout="vertical">
          <div class="row">
            <div class="col-md-4">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label title="Periodo" class>Periodo</label>
                </div>
                <div class="ant-col ant-form-item-control-wrapper">
                  <div class="ant-form-item-control">
                    <span class="ant-form-item-children">
                      <a-month-picker
                        :v-model="filtrosLocal.month"
                        :default-value="moment(moment(), dateFormat)"
                        :format="dateFormat"
                        @change="handleCalendarChange"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="sysAdminUser" class="col-md-4">
              <a-form-item label="Canal de Venda">
                <a-select
                  v-model="filtrosLocal.idSalechannel"
                  @change="handleSaleChannelChange"
                >
                  <a-select-option value=""> Selecione </a-select-option>
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in saleChannels"
                    :key="`adquirente-${index}`"
                  >
                    {{ item.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div v-if="showCostCenter" class="col-md-4">
              <a-form-item label="Centro de Custo">
                <a-select v-model="filtrosLocal.idCostCenter">
                  <a-select-option value=""> Selecione </a-select-option>
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in costCenters"
                    :key="`costcenter-${index}`"
                  >
                    {{ item.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
            </div>
            <div class="col-md-2">
              <b-button
                class="col-12"
                @click="filtrar"
                variant="outline-primary"
                >Filtrar</b-button
              >
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Main table element -->

      <div class="card">
        <div class="card-body">
          <b-table
            show-empty
            stacked="md"
            striped
            :borderless="true"
            :items="displayItens"
            :fields="fields"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template v-slot:cell(date)="text">
              {{ moment(text.value).format("MM/YYYY") }}</template
            >

            <template v-slot:cell(amount)="text">
              {{ text.value | money }}</template
            >
            <template v-slot:cell(ticket)="text">
              {{ text.value | money }}</template
            >
          </b-table>
        </div>
      </div>
    </template>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @input="onChangePage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import { TransactionResource } from "@/resources/Transaction.resource.js";
import moment from "moment";
export default {
  name: "ListInvoice",

  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 20,
        month: moment(moment(), "MM/YYYY"),
      },
      itens: [],
      displayItens: [],
      costCenters: [],
      saleChannels: [],
      fields: [
        {
          key: "saleChannel",
          label: "Canal de Vendas",
        },
        {
          key: "costCenter",
          label: "Centro de Custo",
        },
        {
          key: "merchant",
          label: "Estabelecimento",
        },
        {
          key: "amount",
          label: "Faturamento",
          scopedSlots: { customRender: "amount" },
        },
        {
          key: "transactions",
          label: "Vendas",
        },
        {
          key: "ticket",
          label: "Ticket Médio",
          scopedSlots: { customRender: "ticket" },
        },
        {
          key: "date",
          label: "Periodo",
          scopedSlots: { customRender: "dtPayment" },
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100, 150],
      sortBy: "idInvoice",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      dateFormat: "MM/YYYY",
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
    };
  },
  methods: {
    moment,
    handleCalendarChange(date) {
      this.filtrosLocal.month = date;
    },
    handleSaleChannelChange() {
      this.filtrosLocal.idCostCenter = null;
    },
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        this.loading = true;

        var filtros = { ...this.filtrosLocal };

        filtros.month = filtros.month.format("YYYY-MM-01T00:00:00");

        TransactionResource.getMonthSummaryBySeller(filtros)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason:
                      "Erro ao solicitar os dados, por favor tente novamente",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },
    getCostCenters() {
      this.$api
        .get("v1/costCenter/keyValue")
        .then((result) => {
          this.costCenters = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    getSaleChannels() {
      this.$api
        .get("v1/saleChannel/keyValue")
        .then((result) => {
          this.saleChannels = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    onChangePage(a) {
      this.filtrosLocal.index = a;
      this.getLista();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 50,
        date: moment(moment(), "MM/YYYY"),
      };
      this.filtrar();
    },
    filtrar() {
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0);
        return result;
      } catch (e) {
        return false;
      }
    },

    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
    if (this.showCostCenter) this.getCostCenters();
    if (this.sysAdminUser) this.getSaleChannels();
  },
};
</script>
